document.addEventListener('turbo:load', function () {
  setTimeout(function () {
    const scrollTarget = $('#scroll');
    if (scrollTarget.length > 0) {
      $('html, body').animate({
        scrollTop: scrollTarget.offset().top
      }, 555);
    }
  }, 50); // kleine Verzögerung hilft bei DOM-nachladungen
});
